import styled from "styled-components";
import { globalStyles } from "../../../util/globalStyles";

export const ConstructionStatusWrapper = styled.div``

export const CardsWrapper = styled.div`
    margin-top: 4rem;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-row-gap: 2rem;
    grid-column-gap: 2rem;

    @media only screen and (max-width: ${globalStyles.breakpoints.large}) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        grid-template-columns: minmax(0, 1fr);
    }
`

export const Image = styled.img`
    height: 100%;
    width: 100%;
    border-radius: 1rem;
`